import type { LaborCostEmployee } from "@/pages/human-resources/time-management/business/analysis/LaborCostEmployee.ts";
import { parseIsoDateTime } from "@/shared/utils/Dates.ts";

export type LaborCostEmployeeOut = Omit<LaborCostEmployee, "contractStart"> & {
  contractStart: string;
};

export function mapToLaborCostEmployee(
  dto: LaborCostEmployeeOut,
): LaborCostEmployee {
  return {
    ...dto,
    contractStart: parseIsoDateTime(dto.contractStart),
  };
}
